/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const distributorAccountRouters = {
  path: '/distributorAccount',
  component: Layout,
  name: 'distributorAccount',
  meta: {
    title: '经销商账号管理',
    icon: 'el-icon-files'
  },
  children: [
    {
      path: 'list',
      // component: () => import('@/views/distributor/list'),
      component: () => import('@/views/dealer/list'),
      name: 'distributorAccountList',
      meta: { title: '经销商账号' }
    }
  ]
}

export default distributorAccountRouters
